import React, { FunctionComponent } from "react";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { Collapsible } from "@multiweb/reactComponents";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { createUpdateGeneralCollapsibleState } from "../../../actions";
import { LOC_VARIABLES } from "../../../locKeys";
import { getGeneralPanelStateContainer, getVariables } from "../../../selectors";
import { IVariable, WorkflowEditorProps } from "../../../types";
import { PropertyRowComponent } from "../components";

type VariablesContainerProps = {
    readonly isOpen: boolean;
    readonly variables: readonly IVariable[];
    readonly updateVariablesPanelState: (isExpanded: boolean) => void;
    readonly variablesText: string;
};

const VariablesContainerComponent: FunctionComponent<VariablesContainerProps> = ({ isOpen, variables, updateVariablesPanelState, variablesText }) => (
    <Collapsible qa="variables-collapsible-section" captionText={variablesText} defaultOpened={isOpen} onExpansionChange={updateVariablesPanelState} handleExpansionExternally>
        {variables.map(({ name, value }, index) =>
            <PropertyRowComponent key={`${name}${index}`} description={name} value={value} />,
        )}
    </Collapsible>
);

type StateProps = Pick<VariablesContainerProps, "isOpen" | "variables" | "variablesText">;

const mapStateToProps: MapStateToProps<StateProps, WorkflowEditorProps, IAppState> = (state, { hostKey }) => ({
    isOpen: getGeneralPanelStateContainer(state, hostKey, "VARIABLES").isOpen,
    variables: getVariables(state, hostKey),
    variablesText: getPrimaryText(state, LOC_VARIABLES) ?? "Proměnné",
});

type DispatchProps = Pick<VariablesContainerProps, "updateVariablesPanelState">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, WorkflowEditorProps> = (dispatch, { hostKey }) => ({
    updateVariablesPanelState: (isExpanded) => dispatch(createUpdateGeneralCollapsibleState(hostKey, "VARIABLES", isExpanded)),
});

export const VariablesContainer = connect(mapStateToProps, mapDispatchToProps)(VariablesContainerComponent);
